module.exports = __webpack_public_path__ + "img/JZ.972f4120.png";